<span
  [matTooltip]="term | glossarydef"
  [innerHtml]="term | glossarylink: text"
></span>
